import { render } from "./TheCertificationsModalContent.vue?vue&type=template&id=0530f111&ts=true"
import script from "./TheCertificationsModalContent.vue?vue&type=script&lang=ts"
export * from "./TheCertificationsModalContent.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__